<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary"
        pill
        @click="createEquipmentReport"
        v-if="hasPermission('create_equipment_report')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Add New</span>
      </b-button>
    </div>

    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="Site"
              label-for="site"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="equipment_reports"
        details-td-class="m-1 p-1"
        small
        v-if="hasPermission('read_equipment_report')"
        :per-page="0"
      >
        <template #cell(site_data)="row">
          {{
            row.item.site_data ? row.item.site_data.name : ""
          }}
        </template>

        <template #cell(manage)="row">
          <b-button
            variant="success"
            pill
            size="sm"
            class="mr-50"
            @click="editEquipmentReport(row.item)"
            v-if="hasPermission('update_equipment_report')"
          >
            Edit
          </b-button>

          <b-button
            variant="primary"
            pill
            size="sm"
            class="mr-50"
            @click="downloadImage(row.item.esmr)"
            v-if="hasPermission('read_equipment_report')"
            :disabled="row.item.esmr ? false:true"
          >
            Download Report
          </b-button>
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
    <CreateEquipmentReportModal
      @modalClosed="onModalClosed"
      :key="`create-${createEquipmentReportModalCount}`"
    />
    <EditEquipmentReportModal
      :equipment_report="equipment_report"
      @modalClosed="onModalClosed"
      :key="`edit-${editEquipmentReportModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateEquipmentReportModal from "@/components/equipment_report/CreateEquipmentReportModal.vue";
import EditEquipmentReportModal from "@/components/equipment_report/EditEquipmentReportModal.vue";
import util from "@/util.js";
import VueGauge from 'vue-gauge';


export default {
  components: {
    CreateEquipmentReportModal,
    EditEquipmentReportModal,
    VueSelectPaginated,
    VueGauge,
  },
  data() {
    return {
      fields: [
        { key: "site_data", label: "Site" },
        { key: "expiry_date", label: "Expiry Date" },
        { key: "manage", label: "Actions" },
      ],
      
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      equipment_reports: [],
      equipment_report: {},
      createEquipmentReportModalCount: 0,
      editEquipmentReportModalCount: 0,
      searchTypes: [
        { value: 1, name: "Site" },
      ],
      searchType: null,
      sites: [],
      site: "",            
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();
    const sites =  await this.getSitesDDL();
    this.sites = sites.data;
  },
  methods: {
    ...mapActions({
      getSitesDDL: "appData/getSitesDDL",
      getEquipmentReports: "appData/getEquipmentReports",
    }),
    async search() {
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getEquipmentReports({
          pageNumber: this.currentPage,      
          site: this.site,      
        });
        this.equipment_reports = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    createEquipmentReport() {
      this.createEquipmentReportModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-equipment-report-modal");
      });
    },
    editEquipmentReport(equipment_report) {
      this.equipment_report = equipment_report;
      this.editEquipmentReportModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-equipment-report-modal");
      });
    },
    async removeEquipmentReport(equipment_report) {
      this.equipment_report = equipment_report;
      try {
        const res = await this.deleteEquipmentReport({
          pk: this.equipment_report.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "Emergency Scenario Drill deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    downloadImage(imageUrl) {
      window.open(imageUrl, '_blank');
    },

    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
